import { format } from "date-fns";

export function serializeQaReportDate(value: unknown): unknown {
  return value instanceof Date ? format(value, "yyyy-MM-dd") : value;
}

export function serializeFinanceReportDates<
  T extends { startDate?: unknown; endDate?: unknown },
>(filters: T): T {
  return {
    ...filters,
    startDate: serializeQaReportDate(filters.startDate),
    endDate: serializeQaReportDate(filters.endDate),
  };
}

export function buildFinanceWorkOrderOptionsUrl(
  startDate: unknown,
  endDate: unknown,
): string | null {
  const from = serializeQaReportDate(startDate);
  const to = serializeQaReportDate(endDate);

  if (typeof from !== "string" || !from || typeof to !== "string" || !to) {
    return null;
  }

  return `finance/report-options/work-orders?${new URLSearchParams({
    from,
    to,
  }).toString()}`;
}
